// extracted by mini-css-extract-plugin
export default {"Chart":"dRPKI","Detail":"_1UlSP","Value":"_3F8lQ","Title":"_3hvDR","Donut":"_2p3Wm"};